
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index5qBQBAHf3ua5fcKukkaEq8sFRNuaQrsj8391dkEkgS0Meta } from "/opt/dist/app/pages/index.vue?macro=true";
import { default as legal61XaUBWrHqAe4x9rdOB0YGmMfijkv8pZxu7ggiaJ7csMeta } from "/opt/dist/app/pages/legal.vue?macro=true";
import { default as priceqxtrlMy7CjLXp_UhdniuN5zPiWiZAzXxNTEJrI9kpRAMeta } from "/opt/dist/app/pages/price.vue?macro=true";
import { default as uikitCsLw0qBHEwu0VAqrRSnXcFi7RUuxH4tjOcjmw2bjRbIMeta } from "/opt/dist/app/pages/uikit.vue?macro=true";
import { default as brands4T1TwtU3C66crB_gOthM1F_EnqTmdBNhWUcNUpYj9p8Meta } from "/opt/dist/app/pages/brands.vue?macro=true";
import { default as comparePErAN8o16e237Wfn4GUU0YjCTKTH9jD_cChbwJJj_4cMeta } from "/opt/dist/app/pages/compare.vue?macro=true";
import { default as favoriteIPrTKQYETNBGU1hgvO5xIyGpX1gGOraHGvmv9Yu0y8gMeta } from "/opt/dist/app/pages/favorite.vue?macro=true";
import { default as index3Bi8heVib4_lxi8jl4zKzvGYbSFhg33mM6TN349ik_8Meta } from "/opt/dist/app/pages/about/index.vue?macro=true";
import { default as indexGeSILC2YlhGjZwbH7Ri_42UdTgqBX6RZ8YWPGMY33v8Meta } from "/opt/dist/app/pages/press/index.vue?macro=true";
import { default as price_45clearj_OueSKpclYskXe1Db3aK2Vl6JQkxM9rhTMzQcRdmVcMeta } from "/opt/dist/app/pages/price-clear.vue?macro=true";
import { default as indexZvM5l26ABdKituSZHESKghD9RnclvVIyJSBFuKpc8BYMeta } from "/opt/dist/app/pages/search/index.vue?macro=true";
import { default as index4bOFMIJ3nrBciQtat_J3DjJ0F0w2c90_cwiOyeqjd0gMeta } from "/opt/dist/app/pages/catalog/index.vue?macro=true";
import { default as indexRga0b_GhQddR3AK8qZERpCHH9stENLBUMDOG5rNpxpkMeta } from "/opt/dist/app/pages/contacts/index.vue?macro=true";
import { default as indexdabsq58X2tRcmnM_htBlCs_0mHp6bUgxwwPSZeecLzoMeta } from "/opt/dist/app/pages/discount/index.vue?macro=true";
import { default as indexpm_q_XqbgHtodsNdxM1cmuHQOdDiPWR18HRsQmDvbTMMeta } from "/opt/dist/app/pages/magaziny/index.vue?macro=true";
import { default as searchTSzLhl0p8C5_iQVPusScCC9JOHdZHTAMIvCKyRPPG_oEoMeta } from "/opt/dist/app/pages/search/searchTS.ts?macro=true";
import { default as user_45agreementotWrwRA1_pLreCBg_B1bgq92EQT_E9g_prF0LYTVl6MMeta } from "/opt/dist/app/pages/user-agreement.vue?macro=true";
import { default as indexTshhkq9WrQc7nMDTSFPa0_b7YJtUryvi6PKF9PaWYRXk8Meta } from "/opt/dist/app/pages/contacts/indexTs.ts?macro=true";
import { default as indexw0xsJL5YoFVqxrgfbPAnZgKpVq_msHUp1_gV6bFpCXcMeta } from "/opt/dist/app/pages/promokody/index.vue?macro=true";
import { default as kak_45oformit_45zakazbM8tQDqyhF95bgBH4VOD1AEGnqexdztw20VzAzANLQgMeta } from "/opt/dist/app/pages/kak-oformit-zakaz.vue?macro=true";
import { default as oplata_45i_45dostavkaQvM83DxZbMT4H1Rdu6QL4uu2o_xfA2uZpf8_HDbJqkcMeta } from "/opt/dist/app/pages/oplata-i-dostavka.vue?macro=true";
import { default as indexJTYZUgIlkEyOTugrVCwdthQBEaPZxtrV9QKJkSFHf3UMeta } from "/opt/dist/app/pages/promo/[[slug]]/index.vue?macro=true";
import { default as mobile_45purchase_45termsUWTwH18yHkx_iSZCXk0JdIXRWmaer4zy_Wv3pT2TqBAMeta } from "/opt/dist/app/pages/mobile-purchase-terms.vue?macro=true";
import { default as recommendation_45systemvj2l3ERauOY_hAcCH7yJk9YmZPwx_Je_KQU6Gagq_ngMeta } from "/opt/dist/app/pages/recommendation-system.vue?macro=true";
import { default as indexiUpXHT9yrjYKfVVXdRcAVzW24p3wDHChuR_0ZJ8Dz8QMeta } from "/opt/dist/app/pages/email-unsubscribe/index.vue?macro=true";
import { default as lekarstvennye_45preparatycAnT1Ff6bKILjOCJRZ6Ps5tZOkhP6XdECxOJkj09fK8Meta } from "/opt/dist/app/pages/lekarstvennye-preparaty.vue?macro=true";
import { default as obmen_45vozvrat_45garantiyarr_dqWr9NTSMKy1Hd_jjRi8cZUqKPVVFbEOr364DBi8Meta } from "/opt/dist/app/pages/obmen-vozvrat-garantiya.vue?macro=true";
import { default as _91type_93wPBEXTRrdvhPEAgzaH2Z4tZ7DXj8CXzIHmQ1gvN2FjUMeta } from "/opt/dist/app/pages/email-unsubscribe/[type].vue?macro=true";
import { default as index8kcUChGNqgEGryxfywu4kvnNqvKM9YmS96G5nR0juasMeta } from "~/pages/index.vue?macro=true";
import { default as PageDistributorOiUG9aS6rJYP_pxe9aynG_aRzqlRGdXhdvfccs1YMdgMeta } from "~/components/distributor/PageDistributor.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/opt/dist/app/pages/index.vue")
  },
  {
    name: "legal",
    path: "/legal",
    component: () => import("/opt/dist/app/pages/legal.vue")
  },
  {
    name: "price",
    path: "/price",
    component: () => import("/opt/dist/app/pages/price.vue")
  },
  {
    name: "uikit",
    path: "/uikit",
    meta: uikitCsLw0qBHEwu0VAqrRSnXcFi7RUuxH4tjOcjmw2bjRbIMeta || {},
    component: () => import("/opt/dist/app/pages/uikit.vue")
  },
  {
    name: "brands",
    path: "/brands",
    component: () => import("/opt/dist/app/pages/brands.vue")
  },
  {
    name: "compare",
    path: "/compare",
    component: () => import("/opt/dist/app/pages/compare.vue")
  },
  {
    name: "favorite",
    path: "/favorite",
    component: () => import("/opt/dist/app/pages/favorite.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/opt/dist/app/pages/about/index.vue")
  },
  {
    name: "press",
    path: "/press",
    component: () => import("/opt/dist/app/pages/press/index.vue")
  },
  {
    name: "price-clear",
    path: "/price-clear",
    component: () => import("/opt/dist/app/pages/price-clear.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/opt/dist/app/pages/search/index.vue")
  },
  {
    name: "catalog",
    path: "/catalog",
    component: () => import("/opt/dist/app/pages/catalog/index.vue")
  },
  {
    name: "contacts",
    path: "/contacts",
    component: () => import("/opt/dist/app/pages/contacts/index.vue")
  },
  {
    name: "discount",
    path: "/discount",
    component: () => import("/opt/dist/app/pages/discount/index.vue")
  },
  {
    name: "magaziny",
    path: "/magaziny",
    component: () => import("/opt/dist/app/pages/magaziny/index.vue")
  },
  {
    name: "search-searchTS",
    path: "/search/searchTS",
    meta: searchTSzLhl0p8C5_iQVPusScCC9JOHdZHTAMIvCKyRPPG_oEoMeta || {},
    component: () => import("/opt/dist/app/pages/search/searchTS.ts")
  },
  {
    name: "user-agreement",
    path: "/user-agreement",
    component: () => import("/opt/dist/app/pages/user-agreement.vue")
  },
  {
    name: "contacts-indexTs",
    path: "/contacts/indexTs",
    component: () => import("/opt/dist/app/pages/contacts/indexTs.ts")
  },
  {
    name: "promokody",
    path: "/promokody",
    component: () => import("/opt/dist/app/pages/promokody/index.vue")
  },
  {
    name: "kak-oformit-zakaz",
    path: "/kak-oformit-zakaz",
    component: () => import("/opt/dist/app/pages/kak-oformit-zakaz.vue")
  },
  {
    name: "oplata-i-dostavka",
    path: "/oplata-i-dostavka",
    component: () => import("/opt/dist/app/pages/oplata-i-dostavka.vue")
  },
  {
    name: "promo-slug",
    path: "/promo/:slug?",
    component: () => import("/opt/dist/app/pages/promo/[[slug]]/index.vue")
  },
  {
    name: "mobile-purchase-terms",
    path: "/mobile-purchase-terms",
    component: () => import("/opt/dist/app/pages/mobile-purchase-terms.vue")
  },
  {
    name: "recommendation-system",
    path: "/recommendation-system",
    component: () => import("/opt/dist/app/pages/recommendation-system.vue")
  },
  {
    name: "email-unsubscribe",
    path: "/email-unsubscribe",
    component: () => import("/opt/dist/app/pages/email-unsubscribe/index.vue")
  },
  {
    name: "lekarstvennye-preparaty",
    path: "/lekarstvennye-preparaty",
    component: () => import("/opt/dist/app/pages/lekarstvennye-preparaty.vue")
  },
  {
    name: "obmen-vozvrat-garantiya",
    path: "/obmen-vozvrat-garantiya",
    component: () => import("/opt/dist/app/pages/obmen-vozvrat-garantiya.vue")
  },
  {
    name: "email-unsubscribe-type",
    path: "/email-unsubscribe/:type()",
    component: () => import("/opt/dist/app/pages/email-unsubscribe/[type].vue")
  },
  {
    name: "index2",
    path: "/index",
    component: () => import("~/pages/index.vue")
  },
  {
    name: "dynamic",
    path: "/:any/:some*",
    component: () => import("~/components/distributor/PageDistributor.vue")
  }
]